module.exports = __webpack_public_path__ + "img/journal-plus.7c5d2f66.svg";